import { environment } from '../../../environments/environment';

export const URLConstants = {
  // contact sales
  sendMailToSales: environment.API_BASE_URL + '/customer/v1/mailContactSales',
  // shipment tracker
  shipmentTrackerInfo:
    environment.API_BASE_URL + '/customer/v1/shipmentTracker',
  // manifest upload
  manifestTrackInfo: environment.API_BASE_URL + '/customer/v1/manifestTracker',
  signedurl:
    environment.API_BASE_URL + '/customer/v1/manifestUpload/getSignedUrl',
  signedManifest:
    environment.API_BASE_URL + '/customer/v1/manifestUpload/uploadFullmanFile',
  // airway bill - address book
  addressBasedOnAccount:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/fetch/ibcAccount/',
  addressSave:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/create',
  addressUpdate:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/update',
  verifyAddress:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/verify',
  addressDelete:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/delete',
  fetchAddresBookDetails:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/fetch',
  addressFavoutite:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/addressBook/isFavorite',
  airwayHistory:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/fetchAWBHistory',
  // auth
  auth: {
    authorize: environment.API_BASE_URL + '/customer/v1/auth/authorize',
    ipAddress: 'https://api.ipify.org/?format=json',
  },
  // airway bill - generate form
  lookup: environment.API_BASE_URL + '/customer/v1/airWayBillSystem/lookup/',
  masterLookup:
    environment.API_BASE_URL + '/customer/v1/master/masterLookUp/',
  getStateDetails:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/locality/search/',
  getCitiesList:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/lookup/citiesList/',
  shipperAddressBookList:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/getShipperLookupData',
  fetchShipperAddressById:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/fetchAddressById',
  consigneeAddressBookList:
    environment.API_BASE_URL +
    '/customer/v1/airWayBillSystem/getConsigneeLookupData',
  generateAirwayBill:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/create',
  getHsCodeByDescription:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/getHsCode/',
  shareViaEmail:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/shareViaEmail/',
  updateUserDetails: environment.API_BASE_URL + '/customer/v1/user/update',
  getUserProfileDetails:
    environment.API_BASE_URL + '/customer/v1/user/fetchUserProfile',
  linkedAccounts: environment.API_BASE_URL + '/customer/v1/user/linkedAccounts',
  getCityDetails:
    environment.API_BASE_URL + '/customer/v1/airWayBillSystem/getCityDetails/',
} as const;

export function getExternalApiDocsUrl(key: string): string {
  return `${environment.API_BASE_URL}/customer/v1/external/apiDocs/${key}`;
}
